if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        /*
          Sert à éviter qu'un ancien changement de variante
          termine après un changement plus récent.
        */
        this.mediaSwitchRequest = 0;

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });

        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }


      onSlideChanged(event) {
        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }


      /*
        =====================================================
        OMEYA — ANTI FLASH BLANC
        =====================================================

        On ne désactive PLUS l'ancienne image immédiatement.

        On attend d'abord que l'image cible soit réellement
        disponible dans le navigateur.

        Résultat :
        ancienne image
        → nouvelle image chargée
        → changement

        au lieu de :
        ancienne image
        → blanc
        → nouvelle image
      */
      async setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );

        if (!activeMedia) return;


        /*
          Numéro unique pour ce changement.

          Si l'utilisateur clique très vite sur plusieurs couleurs,
          seule la dernière demande sera appliquée.
        */
        const requestId =
          ++this.mediaSwitchRequest;


        /*
          On cherche l'image principale de la nouvelle media.
        */
        const targetImage =
          activeMedia.querySelector(
            '.product__modal-opener--image img'
          ) ||
          activeMedia.querySelector('img');


        /*
          Si c'est une image, on force son chargement avant
          de retirer l'ancienne image active.
        */
        if (targetImage) {
          await this.waitForImage(targetImage);
        }


        /*
          Entre-temps une autre variante a peut-être été demandée.
          Dans ce cas on abandonne cette ancienne demande.
        */
        if (requestId !== this.mediaSwitchRequest) {
          return;
        }


        /*
          Maintenant seulement on effectue réellement
          le changement de média.
        */
        this.activateMedia(
          activeMedia,
          mediaId,
          prepend
        );
      }


      /*
        =====================================================
        ATTENDRE QUE L'IMAGE SOIT PRÊTE
        =====================================================
      */
      waitForImage(image) {
        return new Promise((resolve) => {

          if (!image) {
            resolve();
            return;
          }


          /*
            Le navigateur ne doit pas laisser l'image cible
            en lazy-loading puisqu'on va l'afficher immédiatement.
          */
          image.loading = 'eager';


          /*
            Si elle est déjà chargée, aucune attente.
          */
          if (
            image.complete &&
            image.naturalWidth > 0
          ) {

            /*
              decode() évite aussi le flash pendant
              le décodage réel des pixels.
            */
            if (typeof image.decode === 'function') {

              image
                .decode()
                .catch(() => {})
                .finally(resolve);

            } else {

              resolve();

            }

            return;
          }


          let finished = false;


          const finish = () => {

            if (finished) return;

            finished = true;

            image.removeEventListener(
              'load',
              onLoad
            );

            image.removeEventListener(
              'error',
              onError
            );

            resolve();

          };


          const onLoad = async () => {

            if (
              typeof image.decode === 'function'
            ) {

              try {
                await image.decode();
              } catch (error) {
                /*
                  Si decode() échoue mais que l'image
                  est bien chargée, on continue quand même.
                */
              }

            }

            finish();

          };


          const onError = () => {
            /*
              On ne bloque jamais la galerie
              si une image échoue à charger.
            */
            finish();
          };


          image.addEventListener(
            'load',
            onLoad,
            { once: true }
          );

          image.addEventListener(
            'error',
            onError,
            { once: true }
          );


          /*
            Sécurité :
            impossible de bloquer indéfiniment la galerie.
          */
          window.setTimeout(
            finish,
            1500
          );

        });
      }


      /*
        =====================================================
        CHANGEMENT EFFECTIF DU MEDIA
        =====================================================
      */
      activateMedia(
        activeMedia,
        mediaId,
        prepend
      ) {

        /*
          C'est seulement ici que l'ancienne image
          perd sa classe active.
        */
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {

            element.classList.remove(
              'is-active'
            );

          });


        activeMedia
          ?.classList
          ?.add('is-active');


        if (prepend) {

          if (
            activeMedia.parentElement.firstChild !==
            activeMedia
          ) {

            activeMedia.parentElement.prepend(
              activeMedia
            );

          }


          if (this.elements.thumbnails) {

            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );


            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !==
                activeThumbnail
            ) {

              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );

            }

          }


          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }

        }


        this.preventStickyHeader();


        window.setTimeout(() => {

          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {

            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });

          }


          const activeMediaRect =
            activeMedia.getBoundingClientRect();


          /*
            Ne pas déplacer toute la page
            si l'image est déjà visible.
          */
          if (activeMediaRect.top > -0.5) {
            return;
          }


          const top =
            activeMediaRect.top +
            window.scrollY;


          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });

        });


        this.playActiveMedia(
          activeMedia
        );


        if (!this.elements.thumbnails) {
          return;
        }


        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );


        this.setActiveThumbnail(
          activeThumbnail
        );


        if (activeThumbnail) {

          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );

        }

      }


      setActiveThumbnail(thumbnail) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }


        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {

            element.removeAttribute(
              'aria-current'
            );

          });


        const button =
          thumbnail.querySelector('button');


        if (button) {

          button.setAttribute(
            'aria-current',
            true
          );

        }


        if (
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }


        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }


      announceLiveRegion(
        activeItem,
        position
      ) {

        const image =
          activeItem.querySelector(
            '.product__modal-opener--image img'
          );


        if (
          !image ||
          !this.elements.liveRegion
        ) {
          return;
        }


        /*
          L'image est normalement déjà chargée
          grâce à waitForImage().

          On peut donc annoncer directement son apparition
          sans forcer un nouveau rechargement de image.src.
        */
        this.elements.liveRegion.setAttribute(
          'aria-hidden',
          false
        );


        this.elements.liveRegion.innerHTML =
          window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position
          );


        window.setTimeout(() => {

          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            true
          );

        }, 2000);
      }


      playActiveMedia(activeItem) {

        window.pauseAllMedia();


        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );


        if (deferredMedia) {

          deferredMedia.loadContent(
            false
          );

        }

      }


      preventStickyHeader() {

        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );


        if (!this.stickyHeader) {
          return;
        }


        this.stickyHeader.dispatchEvent(
          new Event(
            'preventHeaderReveal'
          )
        );
      }


      removeListSemantic() {

        if (!this.elements.viewer.slider) {
          return;
        }


        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );


        this.elements.viewer.sliderItems.forEach(
          (slide) => {

            slide.setAttribute(
              'role',
              'presentation'
            );

          }
        );

      }
    }
  );
}